import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'custom-dropdown-list-container',
    templateUrl: './custom-dropdown-list-container.component.html',
    styleUrls: ['./custom-dropdown-list-container.component.scss'],
    standalone: false
})
export class CustomDropdownListContainerComponent {
  @Input() isDropdownOpen = false;
  @Output() isDropdownOpenChange = new EventEmitter<boolean>();

  toggleOpen(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
    this.isDropdownOpenChange.emit(this.isDropdownOpen)
  }
}
